import { GRAY_COLORS } from 'asterX-UI/colors.constant'

export const styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row'
  },
  /* Styles applied to the ul element. */
  ul: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
  },
  divider: {
    height: 2,
    backgroundColor: GRAY_COLORS[200],
    marginBottom: 20
  },
  previousButton: {
    paddingLeft: 0
  },
  nextButton: {
    paddingRight: 0
  },
  countPages: {
    color: GRAY_COLORS[700],
    fontSize: 14,
    fontWeight: 400
  }
}
